module.exports = __webpack_public_path__ + "static/media/non-fungible.d37d90ed.png";